<template>
  <v-select
    v-model="value"
    :items="buildList"
    :no-data-text="noDataText"
    :chips="chips"
    :deletable-chips="chips"
    :attach="attach"
    :multiple="multiple"
    :label="label"
    :item-text="itemText"
    :small-chips="smallChips"
    :rules="rules"
    :hide-details="hideDetails"
    :item-value="itemValue"
    :disabled="disabled"
    clearable
    @change="handlerInput"
    @click="$emit('click')"
  >
    <template v-if="isRegionsType" v-slot:item="{ item, attrs, on }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-action>
          <v-checkbox v-model="attrs.inputValue" />
        </v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>
            {{ item.name }}
          </v-list-item-title>

          <v-list-item-subtitle v-if="item && item.parent">
            {{ item.parent }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-if="search || allSelectButton" #prepend-item>
      <div v-if="search" class="pr-4 pl-4 pb-2">
        <v-text-field
          :label="searchLabel"
          :loading="searchIsLoading"
          :autofocus="true"
          hide-details
          @input="handlerSearch"
        />
      </div>
      <div v-if="allSelectButton" class="pr-4 pl-4 pb-2">
        <v-btn small color="primary" @click="$emit('allSelect', $event)">
          Выбрать все
        </v-btn>
      </div>
    </template>
    <template v-if="value && maxLength && value.length > maxLength" #selection="{ item, index }">
      <v-chip v-if="index < maxLength">
        <span>{{ item[itemText] }}</span>
      </v-chip>
      <span
        v-if="index === 1"
        class="grey--text text-caption"
      >
        (+{{ value.length - maxLength }} {{ getDecl() }})
      </span>
    </template>
    <template v-if="isContentLoading" #append-item>
      <div class="loading-wrap">
        <img src="@/assets/loading.gif" alt="" height="50">
      </div>
    </template>
  </v-select>
</template>

<script>
import declinationOfNumber from '@/utils/declinationOfNumber';

export default {
  name: 'custom-select',
  props: {
    list: {
      type: Array,
      required: true,
    },
    data: [Object, Array, String],
    label: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    searchLabel: {
      type: String,
      default: '',
    },
    chips: {
      type: Boolean,
      default: false,
    },
    attach: {
      type: Boolean,
      default: false,
    },
    search: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
    maxLength: {
      type: [Number, Object],
      default: () => null,
    },
    searchIsLoading: {
      type: Boolean,
      default: false,
    },
    declination: {
      type: Array,
      default: () => [],
    },
    rules: {
      type: Array,
      default: () => [],
    },
    smallChips: {
      type: Boolean,
      default: false,
    },
    itemText: {
      type: String,
      default: () => 'name',
    },
    itemValue: {
      type: String,
      default: () => 'id',
    },
    isContentLoading: {
      type: Boolean,
      default: false,
    },
    allSelectButton: {
      type: Boolean,
      default: false,
    },
    noDataTextProp: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    value: null,
  }),

  computed: {
    buildList() {
      let list = [...this.list];

      if (this.multiple && this.data) {
        list.push(...this.data);
      } else if (this.data) {
        list.push(...this.data);
      }

      list = [...new Set(list)];

      return list;
    },

    noDataText() {
      if (this.noDataTextProp) {
        return this.noDataTextProp;
      }
      return this.isContentLoading ? 'Загрузка данных...' : 'Данные отсутствуют';
    },

    isRegionsType() {
      return this.type === 'regions';
    },
  },

  watch: {
    data() {
      if (this.data) {
        this.$set(this, 'value', this.data);
      }
    },
  },

  created() {
    this.$set(this, 'value', this.data);
  },

  // Этот Watcher дублирует отпраку запроса через handlerInput.
  // Важный момент что в самом начале отработает событие handlerInput или click и
  // если придет изменения в data,
  // то он опять упдет сюда и опять будет выполнятся событие handlerInput
  // watch: {
  //   data: {
  //     immediate: true,
  //     handler(value) {
  //       console.log('watcher');
  //       console.log(value);
  //       if (value && value.length) {
  // зачем фризить объект тоже не понятно
  //         this.value = this.multiple ? [...value] : Object.freeze(value);
  //         if (this.multiple) {
  //           this.onInput(this.value.map(_ => _.id));
  //         } else {
  //           this.onInput(this.value);
  //         }
  //       } else {
  //         this.value = null;
  //         this.onInput(this.value);
  //       }
  //     },
  //   },
  // },

  methods: {
    handlerInput(data) {
      if (this.multiple) {
        return this.$emit(
          'change', data
            .map((element) => element?.id || element)
            .filter((v) => v !== null),
        );
      }

      this.$emit('change', data);
    },

    handlerSearch(event) {
      this.$emit('search', event);
    },

    getDecl() {
      return declinationOfNumber(this.value.length - this.maxLength, this.declination);
    },
  },
};
</script>

<style lang="scss" scoped>
  .loading-wrap {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>
